import * as actions from './task.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { TaskModel } from '@smarttask-common/src/lib/models/Record/Task/Core/TaskModel';

export const taskAdapter = createEntityAdapter<TaskModel>({
    selectId: (x) => x.record_id,
});
export interface TaskState extends EntityState<TaskModel> {
    selected_record_id: string;
}

export const initialState: TaskState = taskAdapter.getInitialState({
    selected_record_id: undefined,
});

export function TaskReducers(state: TaskState = initialState, action: actions.TaskActions) {
    switch (action.type) {
        case actions.TaskActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_record_id: action.selected_record_id };
            //console.log(state);
            return state;

        case actions.TaskActionTypes.ADD_TASK:
            return taskAdapter.addOne(action.task, state);

        case actions.TaskActionTypes.ADD_TASKS:
            return taskAdapter.addMany(action.tasks, state);

        case actions.TaskActionTypes.UPSERT_TASK:
            return taskAdapter.upsertOne(action.task, state);

        case actions.TaskActionTypes.UPSERT_TASKS:
            return taskAdapter.upsertMany(action.tasks, state);

        case actions.TaskActionTypes.UPDATE_TASK:
            return taskAdapter.updateOne(action.task, state);

        case actions.TaskActionTypes.UPDATE_TASKS:
            return taskAdapter.updateMany(action.tasks, state);

        case actions.TaskActionTypes.DELETE_TASK:
            // if(state.selectedTaskId == action.id){
            //   state.selectedTaskId = undefined;
            // }
            return taskAdapter.removeOne(action.id, state);

        case actions.TaskActionTypes.DELETE_TASKS:
            // if(action.ids.indexOf(state.selectedTaskId) > -1){
            //   state.selectedTaskId = undefined;
            // }
            return taskAdapter.removeMany(action.ids, state);

        case actions.TaskActionTypes.DELETE_ALL_TASKS:
            return taskAdapter.removeMany(action.ids, state);

        case actions.TaskActionTypes.DELETE_ALL:
            return taskAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getTaskState = createFeatureSelector<TaskState>('task');

export const { selectIds, selectEntities, selectAll, selectTotal } = taskAdapter.getSelectors(getTaskState);

const getSelectedTaskIdState = (state: TaskState) => {
    return state.selected_record_id;
};
export const getSelectedTaskId = createSelector(getTaskState, getSelectedTaskIdState);

export const getSelectedTask = createSelector(getTaskState, (state: TaskState) => {
    if (state.selected_record_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_record_id];
});
